import * as jQuery from 'jquery';
window.$ = jQuery;
import {config} from 'core/config';
import rest from './shmRest';
import {shmMap} from './shmMap';
import {shmSort} from './shmSort';
import {templateSearchItem} from './templateSearchItem';
import {datetimepicker} from 'jquery-datetimepicker';
import {collapseSideFilter} from 'modules/collapseSideFilter';

const restService = new rest.RestService('/shinomontazh');
const restQuery = new rest.Query(restService, '/shops');
const restMapQuery = new rest.Query(restService, '/points');

export const shmSearch = {
    bindEvents: function() {
        $('#select-datetime').click(function() {
            $('#datetime-value').datetimepicker('show');
        });
        $('#select-datetime-now').click(function() {
            const d = new Date();
            const dateVal = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join('-');
            const timeVal = [d.getHours(), d.getMinutes(), d.getSeconds()].join(':');
            $('#datetime-value').val(dateVal + ' ' + timeVal);
            $('#available').prop('checked', true);
            $('#select-datetime').removeClass('btn-tochki-primary text-light').text('дату и время');
            $(this).addClass('btn-tochki-primary text-light');
        });
        $('.search-button').on('click', function() {
            restQuery.when(window.whenBlock.getDateTime());
            restMapQuery.when(window.whenBlock.getDateTime());
            restQuery.evaluate(shmSearch.evaluateCallback);
            restMapQuery.evaluate(shmMap.evaluateCallbackMap);
        });
        $('.js-show-aviable-find-button').on('click', function() {
            $('#find-by-available-datetime').removeClass('hide');
        });

        $.datetimepicker.setLocale('ru');
        $('#datetime-value').datetimepicker({
            format: 'Y-m-d H:i:s',
            step: 30,
            closeOnDateSelect: false,
            minDate: 0,
            minTime: 0,
            onSelectDate: function(ct, $i) {
                const ctDate = new Date();
                if (shmSearch.formatDate(ct).split(' ')[0] == shmSearch.formatDate(ctDate).split(' ')[0]) {
                    this.setOptions({
                        minTime: 0,
                    });
                } else {
                    this.setOptions({
                        minTime: false,
                    });
                }
            },
            onChangeDateTime: function(ct, $i) {
                $('#available').prop('checked', true);
                $('#find-by-available-datetime').removeClass('d-none');
                $('#select-datetime').addClass('btn-tochki-primary text-light').text(shmSearch.formatDate(ct));
                $('#select-datetime-now').removeClass('btn-tochki-primary text-light');
            },
        });
    },
    init: function() {
        shmSearch.bindEvents();
        shmMap.init();
        shmSort.init();

        window.searchBlock = shmSearch.initSearchBlock('.search-block');
        window.urlChanger = shmSearch.initUrlChanger('.shinomontazh-list');
        window.pagination = shmSearch.initPagination('.pagination-row');
        window.whenBlock = shmSearch.initWhenBlock('#find-by-available-datetime');
        window.searchItems = shmSearch.initSearchItems('.shinomontazh-list');

        restQuery.pageSize(10);
        restQuery.expand('images');
        restQuery.expand('distance');
        restQuery.expand('cost');

        window.searchBlock.on('data:change', function() {
            restQuery.where(window.searchBlock.getWhere());
            restQuery.evaluate(shmSearch.evaluateCallback);
            restMapQuery.where(window.searchBlock.getWhere());
            restMapQuery.evaluate(shmMap.evaluateCallbackMap);
        });

        window.pagination.on('changepage', function(event, page) {
            restQuery.page(page);
            // restQuery.evaluate(evaluateCallbackPage);
        });

        restQuery.where(window.searchBlock.getWhere());

        collapseSideFilter();
    },
    initUrlChanger: function(contentBlock) {
        const publ = $({});
        const contentRoot = $(contentBlock);

        publ.frontBackHandlers = function() {
            try {
                window.addEventListener('popstate', function(e) {
                    if (e.state !== null) {
                        if (e.state.container && e.state.html) {
                            $(e.state.container).html(e.state.html);
                        }
                    }
                }, false);
            } catch (e) {

            }
        };

        publ.getUrl = function() {
            const t = window.searchBlock.getWhere();
            console.log('t');
            console.log(t);
            let url = '/shinomontazh';
            for (const i in t) {
                const e = t[i];
                if (typeof e == 'object') {
                    url += '/' + e[1] + '-' + e[2];
                }
            }

            const page = window.pagination.getPage() - 1;
            if (page > 1) {
                url += '/page-' + page;
            }

            const sort = shmSort.getSort();
            if (sort) {
                url += '/sort-' + sort[0] + '-' + (sort[1] ? 'asc' : 'desc');
            }

            const when = window.whenBlock.getDateTime();
            if (when) {
                url += '/when-' + when.replace(new RegExp('-', 'g'), '_');
            }

            return url;
        };

        publ.replaceState = function() {
            history.replaceState({container: contentBlock, html: contentRoot.html()}, '', window.location);
        };

        publ.setState = function(html) {
            history.pushState({container: contentBlock, html: html}, '', this.getUrl());
        };

        publ.frontBackHandlers();
        publ.replaceState();

        return publ;
    },
    initSearchBlock: function(searchBlockSelector) {
        const root = $(searchBlockSelector);
        const publ = $({});

        root.on('change', 'select, :checkbox', function() {
            restQuery.page(1);
            console.log('set page to 1');
            publ.trigger('data:change');
        });

        publ.getWhere = function() {
            const condition = ['and'];

            root.find(':checkbox:checked, input[type=hidden], select').each(function() {
                const field = $(this).attr('name');
                const value = $(this).val() || 1;

                if (value != -1) {
                    if (field) {
                        condition.push(['=', field, value]);
                    } else {
                        console.warn('Some of checked checkboxes does not have attribute \'name\'');
                    }
                }
            });

            // return ["and", ["<=", "id", 5], [">", "id", "1"]];

            return condition;
        };

        return publ;
    },
    updateDisplayCount: function(response) {
        const displayItems = $('.display-items');
        const displayFrom = displayItems.find('.display-from');
        const displaySince = displayItems.find('.display-since');
        const displayTo = displayItems.find('.display-to');

        displaySince.html(response.firstIndex());
        displayTo.html(response.lastIndex());
        displayFrom.html(response.totalCount());

        displayItems.removeClass('hidden');
    },
    initPagination: function(paginationSelector) {
        const root = $(paginationSelector);
        const publ = $({});

        root.on('click', 'button', function() {
            const page = $(this).data('page');
            publ.trigger('changepage', page);
        });

        publ.getPage = function() {
            return $(root).find('.change-page-button').data('page');
        };

        /** @param {rest.Response} response */
        publ.update = function(response) {
            let html = '';
            console.log('pagination begin update');
            console.log(response);
            const endPage = response.pageCount();

            if (response.currentPage() < endPage) {
                html = `
                    <button 
                        class="btn-white btn-lg w-25 change-page-button" 
                        data-page="${response.currentPage() + 1}">
                            Показать еще 20
                    </button>`;
            } else {
                html = '';
            }

            shmMap.bindEvents();

            root.html(html);
        };

        return publ;
    },
    initSearchItems: function(selector) {
        const root = $(selector);
        const publ = $({});

        publ.update = function(shops, append) {
            console.log('initSearchItems');
            if (!append) {
                root.empty();
            }

            for (let i = 0; i < shops.length; i += 1) {
                if (shops[i]['icon']) {
                    shops[i]['icon'] = shops[i]['icon'];
                    shops[i]['logoclass'] = '';
                } else {
                    shops[i]['logoclass'] = 'hide';
                }

                if (shops[i]['distance']) {
                    shops[i]['distance'] = parseFloat(shops[i]['distance']).toFixed(1);
                    shops[i]['distanceclass'] = '';
                } else {
                    shops[i]['distance'] = '';
                    shops[i]['distanceclass'] = 'd-none';
                }

                if (shops[i]['distance']) {
                    shops[i]['ext_phoneclass'] = '';
                } else {
                    shops[i]['ext_phone'] = '';
                    shops[i]['ext_phoneclass'] = 'd-none';
                }
                if (shops[i]['ext_phone'] == null) {
                    shops[i]['ext_phone'] = '';
                    shops[i]['ext_phoneclass'] = 'd-none';
                }

                if (shops[i]['onlineRecordAvailable']) {
                    shops[i]['onlinerecordclass'] = '';
                } else {
                    shops[i]['onlinerecordclass'] = 'd-none';
                }

                shops[i]['rating'] = shops[i]['rating'];

                console.log(shops[i]);
                const item = templateSearchItem(shops[i]);

                root.append(item);

                window.urlChanger.setState(root.html());
            }
        };

        return publ;
    },
    initWhenBlock: function(selector) {
        const root = $(selector);
        const publ = $({});

        publ.getDateTime = function() {
            return $('#datetime-value').val();
        };

        return publ;
    },
    evaluateCallback: function(response) {
        console.log('data received');

        const shops = response.data;
        window.searchItems.update(shops, 0);
        shmSearch.updateDisplayCount(response);
        window.pagination.update(response);

        let map_id;
    },
    evaluateCallbackPage: function(response) {
        console.log('data received');

        const shops = response.data;
        window.searchItems.update(shops, 1);
        shmSearch.updateDisplayCount(response);
        window.pagination.update(response);
    },
    formatDate: function(date) {
        let dd = date.getDate();
        if (dd < 10) dd = '0' + dd;

        let mm = date.getMonth() + 1;
        if (mm < 10) mm = '0' + mm;

        let yy = date.getFullYear() % 100;
        if (yy < 10) yy = '0' + yy;

        const hh = date.getHours();

        let min = date.getMinutes();
        if (min == 0) min = '00';

        return dd + '.' + mm + '.' + yy + ' ' + hh + ':' + min;
    },
};
